"use strict";var extend = require("raptor-util/extend");
var inherit = require("raptor-util/inherit");
var VNode = require("./VNode");

function VDocumentFragmentClone(other) {
  extend(this, other);
  this.bX_ = null;
  this.bY_ = null;
}

function VDocumentFragment(out) {
  this.bU_(null /* childCount */);
  this.r_ = out;
}

VDocumentFragment.prototype = {
  bW_: 11,

  bZ_: true,

  bO_: function () {
    return new VDocumentFragmentClone(this);
  },

  bm_: function (host) {
    return (host.ownerDocument || host).createDocumentFragment();
  }
};

inherit(VDocumentFragment, VNode);

VDocumentFragmentClone.prototype = VDocumentFragment.prototype;

module.exports = VDocumentFragment;